import { INDEX_MULTIPLIER } from "./constants";


function areObjectsIdentical(obj1: any, obj2: any): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
}

export function DropColumn(columns,dragCol,dropCol){
    if (areObjectsIdentical(dragCol, dropCol)) return;
  
    dragCol.header_title = dropCol.header_title;
  
    let newIndex: number;
    const dropIndex = columns.findIndex(col => col.field === dropCol.field);
  
    if (dragCol.index < dropCol.index) {
      const dropNext = columns[dropIndex + 1];
      const dropNextIndex = dropNext ? dropNext.index : dropCol.index + INDEX_MULTIPLIER;
      newIndex = Number((dropCol.index + dropNextIndex) / 2);
      
    } else {
      const dropPrev = columns[dropIndex - 1];
      const dropPrevIndex = dropPrev ? dropPrev.index : dropCol.index -  INDEX_MULTIPLIER;
      newIndex = Number((dropCol.index + dropPrevIndex) / 2);
    }
  
    return newIndex;
}

